import { useState, useEffect } from "react";
import { useSession } from "@clerk/clerk-react";
import { Menu, Award } from "lucide-react";
import { C } from "../constants/colors";
import { ARCHETYPE_MAP } from "../constants/archetypes";

export function ArchetypeResultsPanel({ isMobile, onMenuOpen, userSettings, saveSettings }) {
  const { session } = useSession();
  const [url, setUrl] = useState(null);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState(null);

  useEffect(() => {
    let cancelled = false;
    session?.getToken().then(token => {
      return fetch("/api/archetype-result", {
        headers: { Authorization: `Bearer ${token}` },
      });
    }).then(r => r.json()).then(data => {
      if (cancelled) return;
      if (data.url) {
        setUrl(data.url);
        if (data.archetypeName && !userSettings?.archetype && saveSettings) {
          const pair = ARCHETYPE_MAP[data.archetypeName] || "";
          saveSettings({ archetype: data.archetypeName, archetypePair: pair });
        }
      } else {
        setErr("No archetype result found yet.");
      }
    }).catch(() => {
      if (!cancelled) setErr("Could not load your results.");
    }).finally(() => {
      if (!cancelled) setLoading(false);
    });
    return () => { cancelled = true; };
  }, [session]);

  return (
    <div style={{ display: "flex", flexDirection: "column", flex: 1, background: "#F8F7FA", height: "100%", overflow: "hidden" }}>
      <div style={{
        background: C.indigo, padding: isMobile ? "13px 14px" : "17px 22px",
        borderBottom: `3px solid ${C.tealLight}`,
        display: "flex", alignItems: "center", gap: 10, flexShrink: 0,
      }}>
        {isMobile && (
          <button onClick={onMenuOpen} style={{ background: "none", border: "none", cursor: "pointer", color: "#fff", padding: "10px 14px 10px 6px", display: "flex", alignItems: "center", minWidth: 44, minHeight: 44, flexShrink: 0 }}>
            <Menu size={24} />
          </button>
        )}
        <Award size={18} color={C.tealLight} />
        <h2 style={{ color: "#fff", margin: 0, fontSize: isMobile ? 15 : 16, fontWeight: 700 }}>Archetype Results</h2>
      </div>
      {loading ? (
        <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", color: "#888", fontSize: 14 }}>
          Loading your results…
        </div>
      ) : err ? (
        <div style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: 40, textAlign: "center" }}>
          <Award size={40} color="#ccc" style={{ marginBottom: 16 }} />
          <p style={{ color: "#666", fontSize: 14, marginBottom: 20 }}>No archetype assessment result found for your account yet.</p>
          <a
            href="https://info.tevrawood.com/archetype-assessment"
            target="_blank"
            rel="noreferrer"
            style={{ color: C.tealLight, fontSize: 13, textDecoration: "underline" }}
          >
            Take the Archetype Assessment →
          </a>
        </div>
      ) : (
        <iframe
          src={url}
          title="Archetype Results"
          style={{ flex: 1, border: "none", width: "100%", height: "100%" }}
          allow="fullscreen"
        />
      )}
    </div>
  );
}
